function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useCallback, useRef, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ActionButton, Dropdown, Tabs, DropableContainer, TitleComponent, MousePositionedTooltip, KEYBOARD_KEYS } from '@keen.io/ui-core';
import { Icon } from '@keen.io/icons';
import { colors } from '@keen.io/colors';
import { BodyText } from '@keen.io/typography';
import { useKeypress } from '@keen.io/react-hooks';
import SupportedInterval from '../SupportedInterval';
import CustomInterval from '../CustomInterval';
import { isCustomInterval } from './utils/isCustomInterval';
import { transformInterval } from './utils/transformInterval';
import { getEventPath } from '../../utils';
import { Container, IntervalManagement, IntervalContainer, DropdownContainer, StyledPlaceholder, TextCenter, TooltipIconContainer } from './Interval.styles';
import { getInterval, setInterval } from '../../modules/query';
import { STANDARD_TAB, CUSTOM_TAB, DEFAULT_STANDARD_INTERVAL, DEFAULT_CUSTOM_INTERVAL } from './constants';
import { TitleWrapper } from '../Extraction/Extraction.styles';
import { AppContext } from '../../contexts';

var Interval = function Interval() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useContext = useContext(AppContext),
      modalContainer = _useContext.modalContainer;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var containerRef = useRef(null);
  var dispatch = useDispatch();
  var interval = useSelector(getInterval);
  var customInterval = isCustomInterval(interval);
  var changeHandler = useCallback(function (interval) {
    return dispatch(setInterval(interval));
  }, []);
  useEffect(function () {
    return function () {
      dispatch(setInterval(undefined));
    };
  }, []);
  var TABS_SETTINGS = [{
    label: t('query_creator_interval.standard'),
    id: STANDARD_TAB
  }, {
    label: t('query_creator_interval.custom'),
    id: CUSTOM_TAB
  }];
  var dropdownMotion = {
    initial: {
      opacity: 0,
      bottom: 0,
      left: '100%',
      width: 300,
      x: 20
    },
    animate: {
      opacity: 1,
      x: 0
    },
    exit: {
      opacity: 0,
      x: 20
    }
  };

  var selectIntervalTooltip = function selectIntervalTooltip() {
    return React.createElement(BodyText, {
      variant: "body2",
      fontWeight: "normal",
      "data-testid": "extraction-limit-hint",
      color: colors.white[500]
    }, t('query_creator_interval.tooltip'));
  };

  var keyboardHandler = useCallback(function (_e, keyCode) {
    if (keyCode === KEYBOARD_KEYS.ESCAPE) {
      setOpen(false);
    }
  }, []);
  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ESCAPE],
    addEventListenerCondition: isOpen,
    eventListenerDependencies: [isOpen]
  });
  return React.createElement(Container, {
    ref: containerRef
  }, React.createElement(TitleWrapper, null, React.createElement(TitleComponent, {
    onClick: function onClick() {
      return !isOpen && setOpen(true);
    }
  }, t('query_creator_interval.label')), React.createElement(MousePositionedTooltip, {
    isActive: true,
    tooltipTheme: "dark",
    tooltipPortal: modalContainer,
    renderContent: selectIntervalTooltip
  }, React.createElement(TooltipIconContainer, null, React.createElement(Icon, {
    type: "info",
    fill: colors.blue['500']
  })))), React.createElement(IntervalManagement, null, React.createElement(IntervalContainer, null, React.createElement(DropableContainer, {
    variant: "secondary",
    placeholder: function placeholder() {
      return React.createElement(StyledPlaceholder, null, "Set interval");
    },
    onClick: function onClick() {
      return !isOpen && setOpen(true);
    },
    isActive: isOpen,
    value: interval,
    onDefocus: function onDefocus(event) {
      var _a;

      if (!((_a = getEventPath(event)) === null || _a === void 0 ? void 0 : _a.includes(containerRef.current))) {
        setOpen(false);
      }
    }
  }, React.createElement(TextCenter, null, interval && transformInterval(interval))), React.createElement(Dropdown, {
    isOpen: isOpen,
    motion: dropdownMotion,
    fullWidth: true
  }, isOpen && React.createElement(Tabs, {
    activeTab: customInterval ? CUSTOM_TAB : STANDARD_TAB,
    onClick: function onClick(tabId) {
      tabId === STANDARD_TAB ? dispatch(setInterval(DEFAULT_STANDARD_INTERVAL)) : dispatch(setInterval(DEFAULT_CUSTOM_INTERVAL));
    },
    tabs: TABS_SETTINGS
  }), React.createElement(DropdownContainer, null, customInterval ? React.createElement(CustomInterval, {
    interval: interval,
    onChange: changeHandler
  }) : React.createElement(SupportedInterval, {
    interval: interval,
    onChange: function onChange(interval) {
      changeHandler(interval);
      setOpen(false);
    }
  })))), interval && React.createElement(ActionButton, {
    action: "remove",
    onClick: function onClick() {
      return dispatch(setInterval(undefined));
    }
  })));
};

export default Interval;